/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-13 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import {
  Modal,
  TextContainer,
  TextStyle,
  ButtonGroup,
  Button,
  Checkbox,
  Stack
} from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { MAPPING_THEME_NAME } from 'src/constants/theme-settings.js';

type Props = {
  show: boolean,
  onCancel: () => void,
  onConfirm: () => void
};

type ComposedProps = Props & WithI18nProps;

class ConfirmChangeTemplateModal extends Component<ComposedProps> {
  state = {
    isCheck: false
  };

  componentWillReceiveProps(nextProps) {
    const { show } = this.props;
    const { show: nextShow } = nextProps;
    if (show && !nextShow) {
      this.reset();
    }
  }

  reset = () => {
    this.setState({
      isCheck: false
    });
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    this.reset();
    onCancel();
  };

  handleConfirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
  };

  handleChangeCheckbox = value => {
    this.setState({
      isCheck: value
    });
  };

  render() {
    const { i18n, show, theme, themeSettingByNameLoading } = this.props;
    const { isCheck } = this.state;
    return (
      <Modal
        open={show}
        onClose={this.handleCancel}
        title={i18n.translate('AdminHTML.ThemeSetting.LayoutModal.confirmChangeTemplate_Title', {
          theme: <span style={{ textTransform: 'capitalize' }}>{MAPPING_THEME_NAME[theme]}</span>
        })}
        footer={
          <Stack distribution="fill" alignment="center">
            <Stack.Item>
              <Checkbox
                label={i18n.translate(
                  'AdminHTML.ThemeSetting.LayoutModal.confirmChangeTemplate_Checkbox'
                )}
                checked={isCheck}
                onChange={this.handleChangeCheckbox}
                disabled={themeSettingByNameLoading}
              />
            </Stack.Item>

            <Stack.Item>
              <div className="Polaris-Stack__Item--custom">
                <ButtonGroup>
                  <Button onClick={this.handleCancel} disabled={themeSettingByNameLoading}>
                    {i18n.translate('AdminHTML.Common.Action.cancel')}
                  </Button>
                  <Button
                    onClick={this.handleConfirm}
                    primary
                    disabled={!isCheck}
                    loading={themeSettingByNameLoading}>
                    {i18n.translate(
                      'AdminHTML.ThemeSetting.LayoutModal.confirmChangeTemplate_UseAnyway'
                    )}
                  </Button>
                </ButtonGroup>
              </div>
            </Stack.Item>
          </Stack>
        }>
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {i18n.translate(
                'AdminHTML.ThemeSetting.LayoutModal.confirmChangeTemplate_Description'
              )}
            </TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(ConfirmChangeTemplateModal);
